import ar from "./ar";
import en from "./en";

// eslint-disable-next-line
export default { ar, en };
